import request from '../../untils/request';

// 线下电费充值
export function OfflineCharge(data) {
  return request({
    url: '/lesseeAccountWater/offlineCharge',
    method: 'post',
    data: data,
  });
}
// 查询某个商户
export function selectOneByLesseeId(data) {
  return request({
    url: '/lessee/selectOneByLesseeId',
    method: 'get',
    params: data,
  });
}

// 售水订单打印数据
export function getPrintData(data) {
  return request({
    url: '/payOrderWater/getPrintData',
    method: 'get',
    params: { orderNo: data },
  });
}
